import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavNotificationsIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M2.14358 7.05106L9.35891 3.44341C9.49966 3.37303 9.66532 3.37303 9.80607 3.44341L17.0214 7.05106C17.3899 7.23532 17.3899 7.76122 17.0214 7.94549L9.80607 11.5531C9.66532 11.6235 9.49966 11.6235 9.35891 11.5531L2.14358 7.94549C1.77506 7.76122 1.77506 7.23532 2.14358 7.05106Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7487 10.832V7.91536L17.082 7.08203"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 8.75V13.2601C3.75 13.9036 4.12049 14.4897 4.70183 14.7657L8.8685 16.744C9.32083 16.9587 9.84583 16.9587 10.2982 16.744L14.4648 14.7657C15.0462 14.4897 15.4167 13.9036 15.4167 13.2601V8.75"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgWrapper>
  );
}
